import { create } from "zustand";

// Settings Tabs
export type SettingsTab = "patient" | "practice" | "processor";

// Settings Form
interface PaymentDashboardSettingsState {
    // Active Settings Form.
    activeForm: SettingsTab;
    setActiveForm: (activeForm: SettingsTab) => void;

    // Settings Forms Handling
    submittingForms: Record<SettingsTab, boolean>;

    // Set Currently Submitting Form
    setSubmittingForms: (settingsTab: SettingsTab, isSubmitting: boolean) => void;
}

/** Hook to track the state of settings for provider form. */
export const usePaymentDashboardSettingsModal = create<PaymentDashboardSettingsState>((set, get) => ({
    // Handle Selected Form
    activeForm: "patient",
    setActiveForm: (activeForm) => set({ activeForm }),
    // Form Handling
    submittingForms: {
        patient: false,
        practice: false,
        processor: false,
    },
    setSubmittingForms: (settingsTab, isSubmitting) => {
        const submittingForms = get().submittingForms;

        submittingForms[settingsTab] = isSubmitting;

        set({ submittingForms });
    },
}));
